import React from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import EnterpriseIcon from "../../assets/images/EnterpriseIcon.svg";
import FreeIcon from "../../assets/images/FreeIcon.svg";
import { useMediaQuery } from "@mui/material";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";

const Step1 = ({
  handeAccountType,
  handleActiveStep1,
  handleStep,
  accountType,
}) => {
  const isMobile = useMediaQuery("(max-width:1400px)");
  const { t } = useTranslation();

  const handleType = (type) => {
    handeAccountType(type);
    handleActiveStep1(true);
    handleStep();
  };
  return (
    <div style={{ marginTop: "32px" }}>
      <Grid container mt={3} spacing={3}>
        <Grid item md={12} xs={12}>
          <div
            className={isMobile ? "account-type-mobile" : "account-type"}
            style={{
              border: accountType === "enterprise" && "3px solid #78C3AE",
            }}
          >
            <img src={EnterpriseIcon} width="122.88px" height="71.04px" />
            <Typography variant="title8">{t("enterprise_account")}</Typography>
            <Typography variant="body5">
              {t("enterprise_description")}
            </Typography>

            <Button
              style={{ position: "absolute", bottom: "20px", width: "85%" }}
              color="secondary"
              variant="contained"
              fullWidth
              onClick={() => handleType("enterprise")}
            >
              {t("try_enterprise")}
            </Button>
          </div>
        </Grid>
        {/* <Grid item md={6} xs={12}>
          <div
            className={isMobile ? "account-type-mobile" : "account-type"}
            style={{ border: accountType === "free" && "3px solid #78C3AE" }}
          >
            <img src={FreeIcon} width="122.88px" height="71.04px" />
            <Typography variant="title8">{t("free_account")}</Typography>
            <Typography variant="body5">{t("free_description")}</Typography>
            <Button
              style={{ position: "absolute", bottom: "20px", width: "85%" }}
              color="secondary"
              variant="contained"
              fullWidth
              onClick={() => handleType("free")}
            >
              {t("select_free")}
            </Button>
          </div>
        </Grid> */}
      </Grid>
    </div>
  );
};

export default Step1;
